import React, { FC, ReactElement } from 'react';
import { AriaDialogProps, useDialog } from 'react-aria';

type DialogProps = AriaDialogProps & { children: ReactElement };

export const Dialog: FC<DialogProps> = ({ children, ...props }) => {
    const ref = React.useRef(null);
    const { dialogProps } = useDialog(props, ref);

    return (
        <div {...dialogProps} ref={ref}>
            {children}
        </div>
    );
};
